import Main from '@/layout/main.vue'
import Blank from '@/layout/blank.vue'
const routes = [
    {
        path: '/AI',
        name: 'AI',
        meta: { title: '积分管理' },
        redirect: '/AI/detail',
        component: Main,
        children: [
            {
                path: '/AI/tryout',
                name: 'tryout_ai',
                meta: {
                    title: '积分管理',
                    parentPath: '/AI',
                    permission: ['view'],
                    hidden: true
                },
                component: () => import('@/views/AI/tryout/AI.vue')
            },
            {
                path: '/AI/detail',
                name: 'AI_detail',
                meta: {
                    title: '积分明细',
                    parentPath: '/AI',
                    permission: ['view']
                },
                component: () => import('@/views/AI/tryout/detail.vue')
            },
            {
                path: '/AI/shops',
                name: 'shops_ldou',
                meta: {
                    title: '积分管理',
                    parentPath: '/AI',
                    permission: ['view']
                },
                component: () => import('@/views/AI/tryout/shops.vue')
            }
        ]
    }
]

export default routes
